<template>
    <div class="c-notificationsV2 c-pendingsV2" ref="pendingsPanel"
        :class="{'is-compact': isMobile}"
        :data-component-name="$options.name"
    >
        <div class="c-notificationsV2-list">
            <div
                class="c-notificationsV2-list__item__wrapper"
                v-if="projectsInbox && projectsInbox.data"
                ref="js-pendings-list"
                @scroll.passive="onProjectsScroll()"
            >
                <div
                    class="c-notificationsV2-list__item"
                    :key="pi"
                    v-for="(project, pi) in projectsInbox.data"
                    :class="{
                        'is-selected': selected==project.id,
                        'is-deleted': deleted.includes(project.id),
                        'is-deleting': deleting.includes(project.id)
                    }"
                    @click="selected = null; $nextTick(()=>selected = project.id)"
                >
                    <div class="-avatar">
                        <UserAvatar 
                            :name="project.name + project.name.split('').reverse().join('')"
                        />
                    </div>
                    <div class="-details flex-grow">
                        <div class="-title__wrap">
                            <div class="-recipient u-text-truncate">
                                {{project.name}}
                            </div>
                            <div>/</div>
                            <div class="-project u-text-truncate">
                                <span class="">{{ project.updated_by.name }}</span>
                            </div>
                        </div>
                        <div class="-title__wrap">
                            <div class="-project" v-if="project.assignmentsDateRange.from == project.assignmentsDateRange.to">
                                affecté le <span class="-recipient">{{ date2str(project.assignmentsDateRange.from).long }}</span>
                            </div>
                            <div class="-project" v-else>
                                affecté du <span class="-recipient">{{ date2str(project.assignmentsDateRange.from).short }}</span>
                                au <span class="-recipient">{{ date2str(project.assignmentsDateRange.to).short }}</span>
                            </div>
                            <div class="q-ml-auto">
                            </div>
                        </div>

                    </div>

                    <div class="-actions">
                        <div class="-updated_at" v-html="getRelativeDate(project.updated_at)"></div>
                        <div class="-count">
                            <span class="-text-blue" v-if="project.assignmentsDateRange.count>0">
                                {{ project.assignmentsDateRange.count }} <q-icon name="assignment_ind"></q-icon>
                            </span>
                            <span class="-text-red" v-if="project.assignmentsDateRange.countCanceled>0">
                                {{ project.assignmentsDateRange.countCanceled }} <q-icon name="assignment_late"></q-icon>
                            </span>
                        </div>
                    </div>

                </div>
            </div>

            <div ref="js-hasMore"
                v-if="!$apollo.loading && projectsInbox && projectsInbox.paginatorInfo && projectsInbox.paginatorInfo.hasMorePages">
            </div>


            <div class="c-notificationsV2-list__item -status">
                <div v-if="$apollo.loading">
                    <q-spinner color="primary" size="1em" class="q-mr-xs" />
                    Chargement en cours...
                </div>
                <div v-else>
                    <div v-if="!projectsInbox || !projectsInbox.data || !projectsInbox.data.length">
                        Aucune affectation en attente
                    </div>
                    <div v-else>
                        Projets {{projectsInbox.data.length}} / {{projectsInbox.paginatorInfo.total}}
                    </div>
                </div>
            </div>

        </div>

        <PendingV2
            ref="selectedProject"
            class="c-notificationsV2-content"
            :class="{'is-selected' : selected }"
            :project="selectedProject"
            :userProfile="userProfile"
            @close-panel="selected = null"
            v-if="selected"
        />

        <div class="c-notificationsV2-info__wrapper js-moreinfo-wrapper" v-show="selectedProject">
            <div class="close-panel-button">
                <q-icon name="arrow_back_ios"
                    onclick="document.querySelector('.js-moreinfo-wrapper').classList.remove('is-active')"
                />
                <div>
                    Détails
                </div>
            </div>

            <div class="-header" v-if="selectedProject">
                <div class="-avatar" v-if="userProfile">
                    <UserAvatar 
                        :name="userProfile.name"
                        :email="userProfile.email"
                    />
                </div>

                <div class="flex-grow">
                    <div class="-assignedTo" v-if="userProfile">
                        <div class="-label q-mr-sm">Affecté à</div>
                        <div class="-value q-mr-sm">
                            {{ userProfile.name }}
                            <UserProfileInfo defaultTab="schedule"
                                v-if="userProfile"
                                :scheduleScrollTo="selectedProject.assignmentsDateRange.from"
                                :currentDate="selectedProject.assignmentsDateRange.from"
                                :userProfile="userProfile"
                                class="q-ml-xs"
                            />
                        </div>
                    </div>

                    <div class="-splitter"></div>
                    
                    <div class="-project" v-if="selectedProject">
                        <div class="-label q-mr-sm">Projet</div>
                        <div class="-value q-mr-sm">
                            {{ selectedProject.name }}
                            <ProjectCardToggle class="q-ml-sm -userprofile-info__toggle" :myAssignments="true" :projectID="selectedProject.id" :size="'14px'" />
                            <a href="" class="q-ml-sm q-link -project" title="Aller au projet"
                                v-if="selectedProject && myProfile && (myProfile.role=='ADMINISTRATOR' || myProfile.role=='MANAGER')"
                                @click.prevent="$eventBus.$emit('jump-to-project', {projectID: selectedProject.id, currentDate: selectedProject.start_date})"
                             >
                                <q-icon name="launch" class="jump-to-project" size="14px"/>
                            </a>
                        </div>
                        <div class="-value q-mt-sm q-mr-sm" v-if="selectedProject.description != ''" v-html="selectedProject.description">
                        </div>
                    </div>

                    <div class="-splitter"></div>

                    <div class="-project">
                        <div class="-label" v-if="(selectedProject.assignmentsDateRange.count + selectedProject.assignmentsDateRange.countCanceled > 1) || (selectedProject.assignmentsDateRange.from != selectedProject.assignmentsDateRange.to)">Affectations</div>
                        <div class="-label" v-else>Affectation</div>

                        <div class="-range" v-if="selectedProject.assignmentsDateRange.from==selectedProject.assignmentsDateRange.to">
                            le {{ date2str(selectedProject.assignmentsDateRange.from).long }}
                        </div>
                        <div class="-range" v-else>
                            du {{ date2str(selectedProject.assignmentsDateRange.from).short }}
                            au {{ date2str(selectedProject.assignmentsDateRange.to).short }}
                        </div>

                        <div class="q-mt-sm" v-if="selectedProject.assignmentsDateRange.count>0">
                            <span class="-text-blue" v-if="selectedProject.assignmentsDateRange.count==1">
                                {{ selectedProject.assignmentsDateRange.count }} affectation en attente
                            </span>
                            <span class="-text-blue" v-else>
                                {{ selectedProject.assignmentsDateRange.count }} affectations en attente
                            </span>
                        </div>

                        <div class="q-mt-sm" v-if="selectedProject.assignmentsDateRange.countCanceled>0">
                            <span class="-text-red" v-if="selectedProject.assignmentsDateRange.countCanceled==1">
                                {{ selectedProject.assignmentsDateRange.countCanceled }} affectation annulée
                            </span>
                            <span class="-text-red" v-else>
                                {{ selectedProject.assignmentsDateRange.countCanceled }} affectations annulées
                            </span>
                        </div>


                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>

import { PROJECTSINBOX } from "@/graphql/notification/queries";
import { MYPROFILE } from '@/graphql/user/queries'
import {relativeDate, date2str} from "@/js/dateUtilities"
import PendingV2 from './PendingV2.vue';

export default {
    name: 'PendingsV2',
    components: {
        PendingV2
    },
    props: {
        userProfile: {
            type: Object,
            default(){
                return null
            }
        },
        isMobile: {
            type: Boolean,
            default: false
        }
    },

    data(){
        return {
            pageSize: 15,
            loading: true,
            myUserProfile: window.myUserProfile,
            selected: null,
            deleted: [],
            deleting: []
        }
    },

    mounted(){
        this.$emit('change-inbox', this.myUserProfile)
        // alert('pending')
        // this.$eventBus.$emit('notifications-count', { projectID: this.projectID } )
    },

    computed: {
        selectedProject: function () {
            let selectedProject = null

            if (this.projectsInbox) {
                selectedProject = this.projectsInbox.data.find(project => project.id == this.selected)
                if (selectedProject) this.refetchProject(this.selected);
            }
            
            return selectedProject
        }
    },
    watch: {
        projectsInbox: function () {
            this.projectsInbox.data.forEach(project => {
                if (project.assignmentsDateRange.count + project.assignmentsDateRange.countCanceled == 0) {
                    setTimeout(() => {
                        this.deleted.push(project.id)
                        if (this.selected == project.id) this.selected = null;
                        this.projectsInbox.data = this.projectsInbox.data.filter(item => item.id != project.id)
                    }, 3000)
                }
            })
        }
    },
    methods: {
        refetchProject(projectID) {
            this.$apollo.query({
                query: PROJECTSINBOX,
                fetchPolicy: 'network-only',
                variables: {
                    id: projectID,
                    userProfileID: this.userProfile.id,
                }
            }).then(function () {
                // console.log(data)
            }.bind(this))
        },

        date2str(date){
            return date2str(date);
        },

        getRelativeDate(date){
            return relativeDate(date);
        },

        selectItem(project) {
            if (this.selected && this.selected.id == project.id) {
                // this.$refs.selectedProject.$apollo.queries.projectDetails.refresh()
            } else {
                this.selected = project;
            }
        },


        onProjectsScroll() {

            clearTimeout(this.notificationScrollTo);
            // if (!this.projectsInbox?.paginatorInfo?.hasMorePages) return;

            this.notificationScrollTo = setTimeout(() => {
                let loadMoreEl = this.$refs["js-hasMore"];
                let loadMoreParent = this.$refs["js-pendings-list"];
                if (loadMoreEl) {
                    var marginTop = loadMoreEl.getBoundingClientRect().top;
                    var innerHeight = loadMoreParent.getBoundingClientRect().height + loadMoreParent.getBoundingClientRect().top;
                    if ((marginTop < innerHeight + 60) && !this.loading) {
                        if (!this.projectsInbox?.paginatorInfo?.hasMorePages) return;
                        this.getMorePendings();
                    }
                }
            }, 300);

        },

        getMorePendings() {
            let page = this.projectsInbox.paginatorInfo.currentPage + 1;
            this.$apollo.queries.projectsInbox.fetchMore({
                variables: {
                    page: page,
                    first: this.pageSize,
                },
                updateQuery: (previousResult, { fetchMoreResult }) => {
                    return {
                        projectsInbox: {
                            __typename: previousResult.projectsInbox.__typename,
                            data: [...previousResult.projectsInbox.data, ...fetchMoreResult.projectsInbox.data],
                            paginatorInfo: fetchMoreResult.projectsInbox.paginatorInfo,
                        }
                    }

                }
            })
        },

    },
    apollo: {

        projectsInbox: {
            query: PROJECTSINBOX,
            fetchPolicy: 'cache-and-network',
            error(error){
                if (error.message) this.$q.notify({type: 'negative', message: 'Oh Oh', caption: error.message});
            },
            variables() {
                return {
                    userProfileID: this.userProfile.id,
                    page: 1,
                    first: this.pageSize,
                }
            },
            watchLoading(isLoading){
                this.loading=isLoading;
            },
            update(data) {
                // // setTimeout(() => {
                //     data.projectsInbox.data.forEach(project => {
                //     // data.projectsInbox.data = data.projectsInbox.data.filter(project => {
                //         if (project.assignmentsDateRange.count + project.assignmentsDateRange.countCanceled == 0) {
                //             this.selected = null;
                //             return false;
                //         }
                //         return true;
                //     })
                // }, 3000)
                // {
                //     return project.userAssignments=[];
                // })
                data.projectsInbox.data = data.projectsInbox.data.filter(project => !this.deleted.includes(project.id))
                this.onProjectsScroll();
                return data.projectsInbox
            },
        },

        myProfile: {
            query: MYPROFILE,
            fetchPolicy: 'cache-first',
            error(error){
                if (error.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: error.message});
            },
        },

    }
}
</script>

<style lang="scss">
    @import "@/scss/components/notificationsV2/NotificationsV2.scss";
    @import "@/scss/components/assignments/PendingsV2.scss";
</style>